import { render } from "./singUpView.vue?vue&type=template&id=9b80618c&scoped=true"
import script from "./singUpView.vue?vue&type=script&lang=js"
export * from "./singUpView.vue?vue&type=script&lang=js"

import "./singUpView.vue?vue&type=style&index=0&id=9b80618c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b80618c"]])

export default __exports__